import React from 'react';

const Card = ({ card, isSelected, onClick, disabled = false, back = false }) => {
  // Card back with diagonal 'Last Card' (draw deck)
  if (back) {
    return (
      <div className="card card-back-simple">
        <div className="card-back-circle"></div>
      </div>
    );
  }

  const getSuitSymbol = (suit) => {
    switch (suit) {
      case 'hearts':
        return '♥';
      case 'diamonds':
        return '♦';
      case 'clubs':
        return '♣';
      case 'spades':
        return '♠';
      default:
        return '';
    }
  };

  const isRed = card.suit === 'hearts' || card.suit === 'diamonds';

  const getCardClass = () => {
    let classes = 'card';
    if (card.rank === 'JOKER') {
      classes += ' joker';
    } else if (card.suit) {
      classes += ` ${card.suit}`;
    }
    if (isSelected) {
      classes += ' selected';
    }
    if (disabled) {
      classes += ' opacity-50 cursor-not-allowed';
    }
    return classes;
  };

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick(card);
    }
  };

  // Joker card: only vertical text, purple, no corners, same size as other cards
  if (card.rank === 'JOKER') {
    return (
      <div 
        className={getCardClass()} 
        onClick={handleClick} 
        title="JOKER"
      >
        <div className="card-joker-vertical-centered">JOKER</div>
        {isSelected && (
          <div className="absolute -top-1 -right-1 w-4 h-4 bg-blue-500 rounded-full flex items-center justify-center">
            <div className="w-2 h-2 bg-white rounded-full"></div>
          </div>
        )}
      </div>
    );
  }

  // All other cards: simple design, rank in corners, suit in center
  return (
    <div 
      className={getCardClass()} 
      onClick={handleClick} 
      title={`${card.rank} ${getSuitSymbol(card.suit)}`}
    > 
      {/* Top-left corner */}
      <div className={`card-corner card-corner-top-left ${isRed ? 'text-red-600' : 'text-black'}`}> 
        {card.rank}
        <br />
        <span className="text-lg">{getSuitSymbol(card.suit)}</span>
      </div>
      {/* Center suit symbol for all cards except Joker */}
      <div className="card-center-ace text-5xl flex items-center justify-center" style={{ color: isRed ? '#dc2626' : '#222' }}>
        {getSuitSymbol(card.suit)}
      </div>
      {/* Bottom-right corner */}
      <div className={`card-corner card-corner-bottom-right ${isRed ? 'text-red-600' : 'text-black'}`}> 
        {card.rank}
        <br />
        <span className="text-lg">{getSuitSymbol(card.suit)}</span>
      </div>
      {isSelected && (
        <div className="absolute -top-1 -right-1 w-4 h-4 bg-blue-500 rounded-full flex items-center justify-center">
          <div className="w-2 h-2 bg-white rounded-full"></div>
        </div>
      )}
    </div>
  );
};

export default Card; 